import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Grid,
  Card,
  Button,
  Tooltip,
  MenuItem,
  TextField,
  Typography,
  CardContent,
} from "@mui/material";
import moment from "moment";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import SendIcon from "@mui/icons-material/Send";
import { FindInPage } from "@mui/icons-material";
import Pagination from "@mui/material/Pagination";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";
import Autocomplete from "@mui/material/Autocomplete";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { esES as localeDate } from "@mui/x-date-pickers/locales";
import "moment/locale/es-mx";
import { account } from "../../shared/Utils";
import { Menu } from "../../app/util/permisos";
import { Acciones } from "../../app/util/permisos";
import { blobToBase64, getOption } from "../../app/util/util";
import { RootStoreContext } from "../../app/store/root";
import { StatusShipment } from "../../app/util/constants";
import {
  EnumStatusCatalogs,
  EnumStatusShipment,
} from "../../shared/Enumerables";

import ModalDetalles from "../../shared/modals/ModalDetalles";
import { ModalComponent } from "../../app/common/ModalComponent";
import ModalViewerPdf from "../../shared/modals/ModalViewerPdf";
import ModalNuevaGuia from "../../components/usuarios/ModalNuevaGuía";
import IconShipmentStatus from "../../shared/components/IconShipmentStatus";
import ModalCreacionGuia from "../../components/proveedores/ModalCreacionGuia";

const EnviosProveedores = () => {
  const navigate = useNavigate();
  const rootStore = useContext(RootStoreContext);
  const {
    entities,
    pageSize,
    lastPage,
    currentPage,
    filterProviders,
    entitiesSearched,
    initialProvidersFilters,
    getAll,
    getById,
    getExcel,
    onFilter,
    getGuideFile,
    getExistGuium,
    getDataFilters,
    setCurrentPage,
    setFilterProviders,
    clearEntitiesSearched,
  } = rootStore.shipmentStore;
  const { entities: destinations, getAllByFilter } = rootStore.destinoStore;

  /* UseStates */
  const [destinos, setDestinos] = useState([]);
  const [disableFilter, setDisableFilter] = useState(true);
  const [urlBlob, setUrlBlob] = useState(undefined);

  const [search, setSearch] = useState(undefined);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditGuia, setOpenEditGuia] = useState(null);
  const [showModalPrint, setShowModalPrint] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [permisosUsuario, setPermisosUsuario] = React.useState([]);
  /* End UseStates */

  useEffect(() => {
    document.title = "Lilofy | Envíos";
    if (
      !account
        .getPermisosUsuario()
        .some((a) => a.clavePermiso == Menu.ProveedorEnvios && a.tienePermiso)
    ) {
      console.log("No tengo permisos para la Envíos de Proveedores");
      navigate("/Proveedores/AccessDenied");
    } else {
      setPermisosUsuario(account.getPermisosUsuario());
    }

    return () => {
      setFilterProviders(initialProvidersFilters);
    };
  }, []);

  useEffect(() => {
    getAllByFilter({
      idEstatus: EnumStatusCatalogs.Activo,
      isSearchByUserIdProvider: true,
    });
  }, []);

  useEffect(() => {
    const data = getDataFilters(filterProviders, true);
    getAll(data);
  }, [currentPage]);

  useEffect(() => {
    if (destinations && destinations.length > 0) {
      let newDestinations = [...destinations];
      newDestinations.push({
        idDestino: null,
        nombreEmpresaDestino: "Todos",
      });
      setDestinos([...newDestinations]);
    }
  }, [destinations]);

  useEffect(() => {
    if (
      !filterProviders?.fechaInicio &&
      !filterProviders?.fechaFin &&
      !filterProviders?.idEstatus &&
      !filterProviders?.idDestino
    )
      setDisableFilter(true);
    else setDisableFilter(false);
  }, [filterProviders]);

  /* Methods */
  const setValueFilter = (key, value) => {
    setFilterProviders({ ...filterProviders, ...{ [key]: value } });
  };

  const handlePaginationChange = (e, p) => {
    setCurrentPage(p - 1);
  };

  const getUrlFile = async (id) => {
    let pdf = await getGuideFile(id);
    const pdfBase64 = await blobToBase64(pdf.data);
    setUrlBlob(pdfBase64);
  };

  const handleClose = (event, reason) => {
    if (reason && reason == "backdropClick") return;
    setShowModalDetail(false);
  };
  /* End Methods */

  return (
    <>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        adapterLocale="es-mx"
        localeText={
          localeDate.components.MuiLocalizationProvider.defaultProps.localeText
        }
      >
        <div className="main-container">
          <div className="mb-2 d-flex" style={{ alignItems: "center" }}>
            <Box
              sx={{ marginRight: "16px", fontSize: 25 }}
              color="primary.main"
            >
              <SendIcon />
            </Box>
            <Typography color="primary" variant="h4">
              Envíos
            </Typography>
          </div>
          <Card className="card">
            <CardContent>
              <Grid
                container
                columnSpacing={2}
                direction={"row"}
                alignItems={"center"}
                columns={14}
              >
                <Grid item lg={2} md={2} sm={4} xs={6}>
                  <DatePicker
                    label="Fecha inicio"
                    value={filterProviders?.fechaInicio || null}
                    onChange={(value) => setValueFilter("fechaInicio", value)}
                    renderInput={({ inputRef, inputProps, InputProps }) => (
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <TextField
                          label="Fecha inicio"
                          size="small"
                          margin="normal"
                          fullWidth
                          ref={inputRef}
                          {...inputProps}
                        />
                        {InputProps?.endAdornment}
                      </Box>
                    )}
                  />
                </Grid>
                <Grid item lg={2} md={2} sm={4} xs={6}>
                  <DatePicker
                    label="Fecha fin"
                    value={filterProviders?.fechaFin || null}
                    onChange={(value) => setValueFilter("fechaFin", value)}
                    renderInput={({ inputRef, inputProps, InputProps }) => (
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <TextField
                          label="Fecha fin"
                          size="small"
                          margin="normal"
                          fullWidth
                          ref={inputRef}
                          {...inputProps}
                        />
                        {InputProps?.endAdornment}
                      </Box>
                    )}
                  />
                </Grid>
                <Grid item lg={3} md={3} sm={4} xs={6}>
                  {/* <TextField
                    size="small"
                    select
                    fullWidth
                    id="selectDestinos"
                    label="Destinos"
                    value={filterProviders?.idDestino || ""}
                    onChange={(e) =>
                      setValueFilter("idDestino", e.target.value)
                    }
                  >
                    {destinos.map((x) => (
                      <MenuItem key={x.idDestino} value={x.idDestino}>
                        {x.nombreEmpresaDestino}
                      </MenuItem>
                    ))}
                  </TextField> */}
                  <Autocomplete
                    size="small"
                    value={filterProviders?.idDestino}
                    options={destinos.map((x) =>
                      getOption(x.nombreEmpresaDestino, x.idDestino)
                    )}
                    id="combo-box-destinos"
                    sx={{ width: "100%" }}
                    onChange={(event, value) => {
                      setValueFilter("idDestino", value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Destinos"
                        size="small"
                        margin="normal"
                      />
                    )}
                  />
                </Grid>
                <Grid item lg={3} md={3} sm={4} xs={6}>
                  {/* <TextField
                    size="small"
                    select
                    fullWidth
                    id="selectEstatus"
                    label="Estatus"
                    value={filterProviders?.idEstatus || ""}
                    onChange={(e) =>
                      setValueFilter("idEstatus", e.target.value)
                    }
                  >
                    <MenuItem value={null}>
                      <em>Seleccionar</em>
                    </MenuItem>
                    {StatusShipment.map((x, index) => (
                      <MenuItem key={index} value={Object.entries(x)[0][1]}>
                        {Object.keys(x)[0]}
                      </MenuItem>
                    ))}
                  </TextField> */}
                  <Autocomplete
                    size="small"
                    value={filterProviders?.idEstatus}
                    options={StatusShipment.map((x) =>
                      getOption(
                        Object.keys(x)[0].replace("_", " "),
                        Object.entries(x)[0][1]
                      )
                    )}
                    id="combo-box-estatus"
                    sx={{ width: "100%" }}
                    onChange={(event, value) => {
                      setValueFilter("idEstatus", value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Estatus"
                        size="small"
                        margin="normal"
                      />
                    )}
                  />
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    onClick={() => {
                      setSearch(undefined);
                      setCurrentPage(0);
                      clearEntitiesSearched();
                      const data = getDataFilters(filterProviders, true);
                      getAll(data);
                    }}
                    disabled={disableFilter}
                  >
                    Buscar
                  </Button>
                </Grid>
                <Grid item>
                  {permisosUsuario.some(
                    (a) =>
                      a.clavePermiso === Acciones.Exportar_información_envío &&
                      a.tienePermiso
                  ) && (
                    <Button
                      variant="export"
                      onClick={async () => {
                        const data = getDataFilters(filterProviders, true);
                        await getExcel(
                          data,
                          `Reporte de envíos (${moment(new Date()).format(
                            "DD/MM/YYYY"
                          )}).xlsx`
                        );
                      }}
                    >
                      Exportar a excel
                    </Button>
                  )}
                </Grid>
              </Grid>

              <Grid
                container
                direction={"row"}
                justifyContent="space-between"
                alignItems={"center"}
                mb={2}
              >
                <Grid item>
                  {permisosUsuario.some(
                    (a) =>
                      a.clavePermiso === Acciones.Nueva_guía && a.tienePermiso
                  ) && (
                    <Button
                      onClick={() => setOpenDialog(true)}
                      variant="contained"
                    >
                      Nueva guía
                    </Button>
                  )}
                </Grid>
                <Grid item>
                  <TextField
                    size="small"
                    margin="normal"
                    fullWidth
                    id="filter"
                    label="Buscar"
                    name="filter"
                    value={search || ""}
                    onChange={(e) => {
                      onFilter(e.target.value);
                      setSearch(e.target.value);
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                {entities.length > 0 ||
                (entitiesSearched && entitiesSearched.length > 0) ? (
                  (entitiesSearched || entities).map((x, index) => (
                    <Grid item xs={12} key={index}>
                      <Card className="card card-button">
                        <CardContent>
                          <Grid
                            container
                            direction={"row"}
                            spacing={2}
                            columns={16}
                            justifyContent="space-between"
                          >
                            <Grid
                              lg={2}
                              md={2}
                              sm={3}
                              xs={4}
                              item
                              direction={"column"}
                              alignItems="center"
                              display={"flex"}
                            >
                              <IconShipmentStatus idStatus={x.idEstatus} />
                              <Typography
                                variant="subtitle"
                                mt={2}
                                className="text-center"
                              >
                                {x.fechaEstatus
                                  ? moment(new Date(x.fechaEstatus)).format(
                                      "DD/MM/YYYY"
                                    )
                                  : ""}
                              </Typography>
                            </Grid>

                            <Grid
                              lg={3}
                              md={3}
                              sm={5}
                              xs={5}
                              item
                              direction={"column"}
                              alignItems="center"
                              display={"flex"}
                              justifyContent={"center"}
                            >
                              <Typography variant="h6">No. de guía</Typography>
                              <Typography variant="subtitle" mt={2}>
                                {`#${x.numeroGuia}`}
                              </Typography>
                            </Grid>

                            {/* <Grid item xs="auto" p={0}>
                                                <Divider orientation="vertical" flexItem/>
                                            </Grid> */}

                            <Grid
                              lg={3}
                              md={3}
                              sm={4}
                              xs={6}
                              item
                              direction={"column"}
                              display={"flex"}
                              justifyContent={"center"}
                            >
                              <Typography variant="h6">
                                Detalles del envío
                              </Typography>
                              <Typography variant="subtitle">
                                {x.descripcionEnvio}
                              </Typography>
                            </Grid>

                            <Grid
                              item
                              lg={3}
                              md={3}
                              sm={4}
                              xs={5}
                              direction={"column"}
                              display={"flex"}
                              justifyContent={"center"}
                            >
                              <Typography variant="h6">Destino:</Typography>
                              <Typography variant="subtitle" mt={2}>
                                {x.destino}
                              </Typography>
                            </Grid>

                            <Grid
                              lg={3}
                              md={3}
                              sm={5}
                              xs={5}
                              item
                              direction={"column"}
                              display={"flex"}
                              justifyContent={"center"}
                            >
                              <Typography variant="h6">
                                Fecha estimada de llegada
                              </Typography>
                              <Typography variant="subtitle" mt={2}>
                                {x.fechaEstimadaLlegada
                                  ? moment(
                                      new Date(x.fechaEstimadaLlegada)
                                    ).format("DD/MM/YYYY")
                                  : ""}
                              </Typography>
                            </Grid>

                            <Grid
                              md={1}
                              sm={2}
                              xs={4}
                              item
                              container
                              direction={{ md: "column", sm: "row", xs: "row" }}
                              display={"flex"}
                              justifyContent={"center"}
                            >
                              {permisosUsuario.some(
                                (a) =>
                                  a.clavePermiso === Acciones.Imprimir_envíos &&
                                  a.tienePermiso
                              ) && (
                                <Tooltip title="Imprimir guía" placement="top">
                                  <PrintIcon
                                    fontSize="large"
                                    onClick={async () => {
                                      await getUrlFile(x.idGuia);
                                      setShowModalPrint(true);
                                    }}
                                    sx={{ marginBottom: "10px" }}
                                  />
                                </Tooltip>
                              )}
                              {permisosUsuario.some(
                                (a) =>
                                  a.clavePermiso ===
                                    Acciones.Ver_detalle_envío && a.tienePermiso
                              ) && (
                                <Tooltip title="Ver detalle" placement="top">
                                  <FindInPage
                                    fontSize="large"
                                    onClick={() => {
                                      getById(x.idGuia);
                                      setShowModalDetail(true);
                                    }}
                                    sx={{ marginBottom: "10px" }}
                                  />
                                </Tooltip>
                              )}
                              {x.idEstatus === EnumStatusShipment.Creado &&
                                permisosUsuario.some(
                                  (a) =>
                                    a.clavePermiso === Acciones.Editar_guía &&
                                    a.tienePermiso
                                ) && (
                                  <Tooltip title="Editar" placement="top">
                                    <EditIcon
                                      fontSize="large"
                                      sx={{ marginBottom: "10px" }}
                                      onClick={() => {
                                        getExistGuium(x.numeroGuia, true).then(
                                          (response) => {
                                            if (response) {
                                              setOpenEditGuia(true);
                                            }
                                          },
                                          (err) => {}
                                        );
                                      }}
                                    />
                                  </Tooltip>
                                )}
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))
                ) : (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="h6" style={{ margin: "auto" }} mt={2}>
                      No se encontraron resultados
                    </Typography>
                  </div>
                )}
              </Grid>
              <Pagination
                count={lastPage}
                page={currentPage + 1}
                onChange={handlePaginationChange}
              />
            </CardContent>
          </Card>
        </div>
      </LocalizationProvider>

      <ModalCreacionGuia
        open={openDialog}
        onClose={() => setOpenDialog(!openDialog)}
      />
      <ModalNuevaGuia
        open={openEditGuia}
        onClose={() => setOpenEditGuia(!openEditGuia)}
        isEdit={true}
        isReceive={false}
      />
      <ModalComponent
        Open={showModalDetail}
        HandleClose={handleClose}
        ClassName="modal-xl"
        Body={() => <ModalDetalles onClose={handleClose} />}
      />
      <ModalComponent
        Open={showModalPrint}
        HandleClose={() => setShowModalPrint(!showModalPrint)}
        ClassName="modal-xl"
        Body={() => (
          <ModalViewerPdf
            urlBlob={urlBlob}
            onClose={() => setShowModalPrint(!showModalPrint)}
          />
        )}
      />
    </>
  );
};

export default observer(EnviosProveedores);
